import type { OverviewSummary, ProgressSummary } from '@todo/shared';
import { get } from './client';

export const overviewApi = {
  /** GET /api/overview - 403 for non-admin roles; the page is hidden for them
   *  anyway, but the server is the enforcement, not the sidebar. */
  get(
    days: 7 | 30 | 90 = 7,
    /** *Ids values are comma-separated id lists (multi-select, ANY-of). */
    filter?: { departmentIds?: string; userIds?: string; projectIds?: string },
  ): Promise<OverviewSummary> {
    return get<OverviewSummary>('/overview', { days, ...filter });
  },

  /**
   * GET /api/overview/progress.
   *
   * `scope` mirrors My Day's three chips. 'all' leaves the decision to the
   * server (org-wide for a Super Admin, personal otherwise); 'mine' and
   * 'delegated' are personal by definition.
   */
  progress(
    days: 7 | 30 | 90 = 7,
    scope: 'all' | 'mine' | 'delegated' = 'all',
  ): Promise<ProgressSummary> {
    return get<ProgressSummary>('/overview/progress', { days, scope });
  },
};
